import React, {useState} from "react";
import { NextButton, PrevButton } from "./NextPrevButtons";
// import {useDispatch, useSelector} from 'react-redux';



 const ViewPokomonInfo =  ({result, isInWishlist, handleOnClickActions, handleBuyNow, paginate}) => {
        

    let itemId = result.cardItems.id;


    return (
        <>
           <div className="viewWrapper">
              <div className="viewHeaderWrapper">
                        <h1 className="hOne">{result.cardItems.name}</h1>
              </div>
                {/*item exist  */}
                <div>
                           
                               {
                                   isInWishlist && isInWishlist.length? <IsAddedItem/> : ""
                               }
                </div>
             <div className="viewGroup">
                     <div className="viewImageWrapper">
                         <img src={result.cardItems.sprites.other.dream_world.front_default}
                           id="viewImageWrapper"
                         />
                     <div id="prevNexBtnWrap" className="prevNexBtnWrap">
                         <PrevButton  paginate={paginate}/> 
                         <NextButton  paginate={paginate}/> 
                     </div>                 
                </div>
                <div className="viewContentWrapper"> 
                    <div className="buttonWrapper">
                         <button className="buyBtnWrapper"
                            onClick={() => handleOnClickActions(itemId)}
                         >
                             add <span className="buyBtnWrapperSpan">to wishlist</span>
                         </button>
                         <button className="addBtnWrapper"
                                onClick={() => handleBuyNow(itemId)}                        
                         >
                             price : €<span>{result.cardItems.weight+3}
                                <span className="priceBuyBtn">Buy</span>
                             </span>
                         </button>
                    </div> 
                {/* {result && console.log(result.cardItems.)}                 */}
                 <section className="sectionWrapper" >
                     <span className="infoOne">weight: <span className="pokeWeight">{result.cardItems.weight}</span></span>   
                     <span className="infoOne">height: <span className="pokeWeight">{result.cardItems.height}</span></span>   

                     <span className="infoThree">experience: {result.cardItems.base_experience}</span>       
                  </section>
                  <section className="sectionMovesWrapper">
                     <span className="infFour">moves : <span className="pokeWeight">
                         {result.cardItems.moves.slice(0, 6).map((el,i) => <span className="pokeMoves" key={i}> <span className="arrayWrap">[</span>{el.move.name}<span className="arrayWrap">]</span></span> )}</span>
                     </span>   
                  </section>
               </div>      
             </div> 
             <div className="viewFooterWrapper">                  
                 <footer className="innerFooterWrapper" >
                     poke infos          
                  </footer>
              </div>      
           </div>
        </>
    )
  }

  export default ViewPokomonInfo;




  const IsAddedItem = () => {


        return(
             <div className="isAddedItemWrapper">
                <p>you already added this item to the wishlist</p>
             </div>
        )
  }